module.exports = __webpack_public_path__ + "static/media/FoldersBad.e958dbd0.png";